import { RouteObject } from 'react-router-dom'

import {
  Groups,
  Home,
  ShowAccount,
  ShowGroup,
  ShowStore,
  Stores,
  SellTreezPage,
  ShowSellTreez,
  FrontendDeploymentPage,
  OpsGroupsDashboard,
  OpsGroupDetail,
  OperationsGroupsLayout,
} from '@/pages'
import { Layout } from '@/components'

export enum ROUTES_PATHS {
  GROUPS = '/groups',
  STORES = '/stores',
  SELL_TREEZ = '/sell-treez',
  FRONTEND_DEPLOYMENT = '/frontend-deployment',
  OPERATIONS_GROUPS = '/operations/groups',
}

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: ROUTES_PATHS.GROUPS,
        handle: { crumb: () => 'Groups' },
        children: [
          {
            index: true,
            element: <Groups />,
          },
          {
            path: ':groupId',
            handle: { crumb: () => 'Group Details' },
            children: [
              {
                index: true,
                element: <ShowGroup />,
              },
              {
                path: ':accountId',
                handle: { crumb: () => 'Account Details' },
                children: [
                  {
                    index: true,
                    element: <ShowAccount />,
                  },
                  {
                    path: ':storeId',
                    element: <ShowStore />,
                    handle: { crumb: () => 'Store Details' },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: ROUTES_PATHS.STORES,
        handle: { crumb: () => 'Stores' },
        children: [
          {
            index: true,
            element: <Stores />,
          },
          {
            path: ':storeId',
            element: <ShowStore />,
            handle: { crumb: () => 'Store Details' },
          },
        ],
      },
      {
        path: ROUTES_PATHS.SELL_TREEZ,
        handle: { crumb: () => 'Sell Treez' },
        children: [
          {
            index: true,
            element: <SellTreezPage />,
          },
          {
            path: ':sellTreezId',
            element: <ShowSellTreez />,
            handle: { crumb: () => 'Sell Treez Details' },
          },
        ],
      },
      {
        path: ROUTES_PATHS.FRONTEND_DEPLOYMENT,
        handle: { crumb: () => 'Front Deployment' },
        element: <FrontendDeploymentPage />,
      },
      {
        path: ROUTES_PATHS.OPERATIONS_GROUPS,
        element: <OperationsGroupsLayout />,
        handle: { crumb: () => 'Store Operations' },
        children: [
          {
            index: true,
            element: <OpsGroupsDashboard />,
            handle: { crumb: () => 'Groups' },
          },
          {
            path: ':groupId',
            element: <OpsGroupDetail />,
            handle: { crumb: () => 'Group Detail' },
          },
        ],
      },
      { path: '*', element: <p>Not found</p> },
    ],
  },
]
